import { render, staticRenderFns } from "./OrderStateLog.vue?vue&type=template&id=0ff436d6&scoped=true"
import script from "./OrderStateLog.vue?vue&type=script&lang=js"
export * from "./OrderStateLog.vue?vue&type=script&lang=js"
import style0 from "./OrderStateLog.vue?vue&type=style&index=0&id=0ff436d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff436d6",
  null
  
)

export default component.exports